<template>
  <section>
    <span :class="[$style.cancellation__heading3, 'mb-3']">Entedemos que as vezes uma pausa é necessária {{ user.firstname }}</span>

    <span :class="[$style.cancellation__heading1, 'mb-3']">Agradecemos a confiança de nos permitir trilhar essa jornada junto a você. Sempre que precisar estaremos aqui prontos para te fornecer conhecimento para continuar conquistando seus objetivos!</span>

    <span :class="[$style.cancellation__heading2, 'mb-3']">Precisamos da sua ajuda para entender seu momento atual para que assim possamos nos tornamos melhores quando você voltar.</span>

    <span :class="[$style.cancellation__heading2, 'mb-4']">
      <strong>Para continuar, informe os motivos do cancelamento e o que podemos fazer para melhorarmos.</strong>
    </span>

    <div class="row">
      <div class="col-md-6">
        <div class="d-flex align-items-center">
          <CancellationReasonForm @submit="proceedCancellation" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import store from '@/store'
import CancellationReasonForm from './CancellationReasonForm'

export default {
  components: {
    CancellationReasonForm
  },
  setup(props, { emit }) {
    const user = store.getters['user/user']

    function proceedCancellation (cancellationFeedback) {
      emit('confirm-cancellation', cancellationFeedback)
    }

    return {
      user,
      proceedCancellation
    }
  }
}
</script>

<style lang="scss" module>
@import "~@/components/cancellation/cancellation.scss";
</style>